<script setup lang="ts">
import { commentsContent } from "~/features/python/ch2/comments/data/comments.content";
</script>

<template>
  <section class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div>
      <h2 class="text-lg font-semibold text-slate-900">Comment kyun likhte hain?</h2>
      <p class="mt-1 text-sm text-slate-600">Comment chhoti si note hoti hai jo hume code samajhne me madad deti hai.</p>
    </div>

    <div class="grid gap-3">
      <article
        v-for="reason in commentsContent.reasons"
        :key="reason.title"
        class="rounded-2xl bg-slate-50 p-4"
      >
        <h3 class="text-sm font-semibold text-slate-900">{{ reason.title }}</h3>
        <p class="mt-1 text-sm text-slate-600">{{ reason.description }}</p>
      </article>
    </div>

    <div class="space-y-3">
      <article
        v-for="example in commentsContent.examples"
        :key="example.id"
        class="rounded-2xl border border-slate-200 bg-slate-50 p-4"
      >
        <h3 class="text-sm font-semibold text-slate-900">{{ example.title }}</h3>
        <pre class="mt-3 overflow-x-auto rounded-xl bg-slate-950 p-3 text-xs leading-6 text-slate-100"><code>{{ example.code }}</code></pre>
        <p class="mt-3 text-sm text-slate-600">{{ example.note }}</p>
      </article>
    </div>
  </section>
</template>
